import addFormats from "ajv-formats";
import ajv from "ajv/dist/2020";
import { FormType } from "./FormType";

// Create an instance of AJV (Another JSON Schema Validator) with additional formats
const AJV = new ajv({
  allErrors: true,
});
addFormats(AJV);

// Import JSON schemas for different form types
const schema_basic_info = require("../../FormSchema/BasicInfo.json");
const schema_interests_activities_goals = require("../../FormSchema/InterestsActivitiesGoals.json");
const schema_experiences = require("../../FormSchema/Experiences.json");


// Add imported schemas to the AJV instance
AJV.addSchema(require("../../FormSchema/DateTime.json"));
AJV.addSchema(require("../../FormSchema/AcademicTerm.json"));
AJV.addSchema(schema_basic_info);
AJV.addSchema(schema_interests_activities_goals);
AJV.addSchema(schema_experiences);

// Validator function to validate form values based on the specified form type
export function validator<T>(formType: FormType): (values: any) => any {
  return (values) => {
    return validate(values, formType);
  };
}

// Internal function to perform validation using AJV
function validate<T>(values: T, formType: FormType): any {
  // Skip validation if the user clicked the back button
  if (
    "submitAction" in (values as any) &&
    (values as any)["submitAction"] == "back"
  ) {
    return null;
  }

  const name = FormType[formType];
  const schema = AJV.getSchema(`file:///${name}.json`);
  if (!schema) return {};

  // Validate the values against the schema
  const valid = schema(values);

  // Return empty object if valid or if there are no schema errors
  if (valid || !schema.errors) return {};

  // Handle schema errors and construct error messages
  let errors: any = {};
  const keys = Object.keys(values as any);
  let propName;
  let msg;
  console.log(schema.errors);
  for (let error of schema.errors) {
    switch (error.keyword) {
      case "required":
        propName = error.params.missingProperty;
        msg = error.message;
        break;
      case "not":
      case "type":
      case "format":
      case "maxLength":
      case "minLength":
      case "minItems":
      case "maxItems":
      case "minimum":
      case "maximum":
        propName = error.instancePath.substring(1);
        msg = error.message;
        break;
      case "enum":
        propName = error.instancePath.substring(1);
        msg = error.message + ": " + error.params["allowedValues"].join(", ");
        break;
      case "contains":
        propName = error.instancePath.substring(1);
        msg = error.message;
        break;
      // TODO: Handle other keyword cases as needed
      default:
        console.error("Unhandled keyword:", error.keyword);
    }

    const path = propName.replace(/\//g, ".");
    setNested(errors, path, msg);
  }
  // Return the constructed errors
  return errors;
}

function setNested(obj: any, path: string, value: any) {
  const keys = path.split(".");
  let curr = obj;

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    // if next key is a number, treat as array
    const isIndex = /^\d+$/.test(keys[i + 1] || "");

    if (i === keys.length - 1) {
      curr[key] = value;
    } else {
      if (!(key in curr)) {
        curr[key] = isIndex ? [] : {};
      }
      curr = curr[key];
    }
  }
}